import styled from "styled-components"

import { color } from "../../../atoms/colors"

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 1170px;
  margin: 0 auto;
  padding: 48px 0 96px;
  @media (max-width: 1200px) {
    padding: 56px 30px 40px 30px;
  }
`
export const PackageTableWrapper = styled.div`
  margin-top: 45px;
  @media (max-width: 1200px) {
    margin-top: 40px;
    border-radius: 8px;
    border-top: ${color.common.transparent};
  }
  @media (max-width: 768px) {
    margin-top: 22px;
  }
`
export const Title = styled.h2`
  color: ${color.oxfordBlue[900]};
  font-weight: 900;
  font-size: 48px;
  line-height: 60px;
  letter-spacing: -0.02em;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 36px;
    line-height: 44px;
  }
  @media (max-width: 576px) {
    font-size: 24px;
    line-height: 32px;
  }
`
export const Subtitle = styled.p`
  color: ${color.copy[700]};
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  margin-top: 10px;
  @media (max-width: 1200px) {
    font-size: 16px;
  }
`
